import React, { useMemo } from 'react';
import ConfirmationDialog from 'components/ConfirmationDialog/ConfirmationDialog';
import { BodyS } from 'components/Typography/Typography';
import { translate } from 'components/Translation';

interface IServicesConfirmationProps {
	isOpen: boolean;
	cancel: () => void;
	submit: () => void;
	header: string;
	dialogBody: string;
	type: types.services.actionType;
}

const ServicesConfirmation = ({ isOpen, cancel, submit, header, dialogBody, type }: IServicesConfirmationProps) => {
	const buttonText: string = useMemo(() => {
		switch (type) {
			case 'TOP_UP':
				return translate('number.services.top.up');
			case 'TURN_ON':
				return translate('numbers.services.turn.on');
			case 'TURN_OFF':
				return translate('numbers.services.turn.off');
		}
	}, [type]);

	return (
		<ConfirmationDialog
			isOpen={isOpen}
			hideDialog={cancel}
			header={header}
			dialogBody={<BodyS>{dialogBody}</BodyS>}
			buttons={[
				{
					text: translate('cancel'),
					onClick: cancel,
					color: 'tertiary-light',
				},
				{
					text: buttonText,
					onClick: submit,
					color: 'primary-light',
				},
			]}
		/>
	);
};

export default ServicesConfirmation;
